import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Colors } from 'utils';
import device from './device';
import { ShotLogo } from 'images';
import { lockPageScroll, unlockPageScroll } from './modalScrollLock';
const ModalWrapper = styled.div`
  .modal {
    &__wrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: #000;
      opacity: 0.5;
      z-index: 1000;
      overflow-y: hidden;
    }
    &__content {
      border-radius: 12px;
      position: fixed;
      top: 50%;
      @media ${device.allMobile} {
        top: 55%;
      }
      left: ${(props) => (props.left ? props.left : '50%')};
      background: #fff;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1001;
      width: ${(props) => (props.width ? props.width : '40%%')};
      @media ${device.allMobile} {
        width: 98%;
      }
    }
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 24px 24px 0;
      position: relative;
    }
    &__title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      img {
        width: 32px;
        height: 25px;
        margin-left: 8px;
      }
    }
    &__close {
      button {
        border: none;
        background: none;
        font-size: 24px;
        color: ${Colors.greyV2};
        margin: 0;
        cursor: pointer;
      }
    }
    &__body {
      padding: 20px;
      max-height: 80vh;
      overflow: auto;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
      @media ${device.allMobile} {
        max-height: 90vh;
        overflow: auto;
        padding-top: 30px;
      }
    }
  }
`;

export default class ModalV2 extends Component {
  componentDidMount() {
    if (this.props.showModal) {
      lockPageScroll();
      this.isScrollLocked = true;
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showModal && this.props.showModal) {
      lockPageScroll();
      this.isScrollLocked = true;
    } else if (prevProps.showModal && !this.props.showModal) {
      unlockPageScroll();
      this.isScrollLocked = false;
    }
  }

  componentWillUnmount() {
    if (this.isScrollLocked) {
      unlockPageScroll();
    }
  }

  render() {
    const { image, title, children, showModal, handelCloseModal, left, width, disableHeader } =
      this.props;

    return (
      <>
        {showModal && (
          <ModalWrapper width={width} left={left ?? '50%'}>
            <div
              className="modal__wrapper"
              onClick={() => {
                handelCloseModal();
              }}
            ></div>
            <div className="modal__content">
              {title !== '' && !disableHeader && (
                <div className="modal__header">
                  <div className='component__spacer' />
                  <div className="modal__title">
                    <img src={ShotLogo} alt={"Logo"} />
                  </div>
                  <div className="modal__close">
                    <button
                      onClick={() => {
                        handelCloseModal();
                      }}
                    >
                      &times;
                    </button>
                  </div>
                </div>
              )}

              <div className="modal__body">{children}</div>
            </div>
          </ModalWrapper>
        )}
      </>
    );
  }
}

ModalV2.propTypes = {
  children: PropTypes.object.isRequired,
  title: PropTypes.string,
  image: PropTypes.string,
  showModal: PropTypes.bool.isRequired,
  handelCloseModal: PropTypes.func.isRequired,
  disableHeader: PropTypes.bool,
};
